import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    listTemplates() {
        return axios.get('emailtemplates')
    },

    updateTemplate(templateId, templateObj) {
        return axios.post(`emailtemplates/update/${templateId}`, templateObj)
    },
    getTemplateById(templateId) {
        return axios.get(`emailtemplates/${templateId}`)
    },
    getShareSurveyTemplate(surveyId) {
        return axios.get(`emailtemplates/getsharesurveytemplate/${surveyId}`)
    },
    shareSurvey(emails, message) {
        return axios.post('emailtemplates/share-survey', { emails , message})
    },
    listEmailAudit() {
        return axios.get('emailtemplates/listEmailAudit')
    }

}